import { Component, OnInit } from "@angular/core";
import { MsVisitorAddComponent } from "../shared/ms-visitor-add/ms-visitor-add.component";
import { DialogService } from "primeng/dynamicdialog";
import { MsVisitorEditComponent } from "../shared/ms-visitor-edit/ms-visitor-edit.component";

@Component({
	selector: "app-multi-station-view-visitors",
	templateUrl: "./multi-station-view-visitors.component.html",
	styleUrls: ["./multi-station-view-visitors.component.css"],
})
export class MultiStationViewVisitorsComponent implements OnInit {
	constructor(private dialogService: DialogService) {}

	ngOnInit(): void {}

	////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////

	SelectedTab: number = 0;
	SelectedVisitor: any;

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////

	onAddVisitor() {
		var ref = this.dialogService.open(MsVisitorAddComponent, {
			header: "Add Visitor",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				IsBlocked: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				// this.onRowUnselect(null);
				// this.loadPerson();
			}
		});
	}

	onEditVisitor() {
		if (this.SelectedVisitor == undefined) {
			// this.errorMessage = "Select a Visitor to Edit";
			return;
		}

		var ref = this.dialogService.open(MsVisitorEditComponent, {
			header: "Edit Visitor",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				IsBlocked: false,
				PersonID: this.SelectedVisitor.PersonID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				// this.onRowUnselect(null);
				// this.loadPerson();
			}
		});
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////////////////

	onVisitorChanged(val) {
		this.SelectedVisitor = val;
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////

	EditDisabled() {
		if (this.SelectedVisitor == undefined) {
			return true;
		} else if (this.SelectedVisitor.PersonID == undefined) {
			return true;
		} else {
			return false;
		}
	}

	////////////////////////////////////////////////////////////////////////
}
